import * as types from "../store/validar.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  DadosValidar: {
    CpfCnpj: undefined,
    Exercicio: undefined,
    InscricaoMunicipal: undefined,
    CodigoVerificacao: undefined
  },
  tokenRecaptcha: "",
  DadosAmbulante: {
    NumeroCracha: undefined,
    CpfCnpj: undefined,
    Ccm: undefined,
    Nome: undefined,
    Praia: undefined,
    Produto: undefined,
    Vencimento: undefined,
    CodigoVerificacao: undefined
  }
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.SET_FROM_QUERY_STRING:
      return state.merge({ DadosValidar: payload });
    case types.SET_DADOS_AMBULANTE:
      return state.merge({ DadosAmbulante: payload });
    default:
      return state;
  }
};

store.registerDynamicModule("validar", reduce);
